import axios from '@/libs/api.request'

export const siteGet = (data) => {
  return axios.request({
    url: '/print/site',
    params: data,
    method: 'get'
  })
}
export const siteSave = data => {
  return axios.request({
    url: '/print/site',
    data,
    method: 'put'
  })
}
export const DelSite = data => {
  return axios.request({
    url: '/print/site/del',
    data,
    method: 'put'
  })
}
export const GetScene = data => {
  return axios.request({
    url: '/print/scene',
    params: data,
    method: 'get'
  })
}
export const SaveScene = data => {
  return axios.request({
    url: '/print/scene',
    data,
    method: 'put'
  })
}
